function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.758 1.76a1 1 0 011-1h12.349a1 1 0 011 1v2.646a1 1 0 11-2 0V2.76H8.934v10.35h1.644a1 1 0 010 2H5.284a1 1 0 010-2h1.65V2.76H2.758v1.646a1 1 0 11-2 0V1.76z",
  fill: "#fff"
})));